import { styled, Theme, Select } from '@mui/material';
import { CoreDialogTitle, CoreDialogContent } from '@youscience/core';
import CoreDatePicker from '@components/CoreDatePicker';

export const sxStyles = {
  dialogWrap: {
    '.MuiPaper-root': {
      borderRadius: '12px',
    },
  },
  formControlItems: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  subtitle: {
    margin: '1.5rem 0',
  },
  formControlItem: {
    width: '100%',

    ' & .MuiFormControl-root': {
      width: '100%',
    },
  },
  formHelperText: {
    '& .MuiFormHelperText-root': {
      textAlign: 'right',
    },
  },
  addResourceWrap: {
    marginBottom: '1.5rem',
  },
};

export const StyledDialogTitle = styled(CoreDialogTitle)(({ theme }) => ({
  ...theme.typography.h4,
  padding: '1.5rem',
  borderBottom: `1px solid ${theme.palette.grey['300']}`,

  [theme.breakpoints.up('sm')]: {
    padding: '2.5rem 3.5rem 1.5rem 3.5rem',
  },
}));

export const StyledDialogContent = styled(CoreDialogContent)(({ theme }) => ({
  maxHeight: '500px',
  padding: '0 1.5rem',

  [theme.breakpoints.up('sm')]: {
    padding: '0 2rem 0 3.5rem',
  },
}));

export const MenuPropsStyles = {
  PaperProps: {
    sx: (theme: Theme) => ({
      '& .Mui-selected': {
        backgroundColor: theme.palette.grey['100'],
      },

      li: {
        '&:hover': {
          // TODO add color to library
          backgroundColor: '#EBF6F7',
        },
      },
    }),
  },
};

export const StyledDialogFormControls = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  width: '100%',
  gap: '2rem',
}));

export const StyledDatePicker = styled(CoreDatePicker)(() => ({
  '& label.MuiFormLabel-root': {
    top: '-5px',
  },

  '& > div:first-of-type': {
    height: '45px',
  },
}));

export const StyledSelect = styled(Select)(({ theme }) => ({
  boxShadow: 'none',

  '& > svg:first-of-type': {
    color: theme.palette.common.black,
  },

  '& .MuiInputBase-input': {
    padding: '11px',
  },
}));
